import cn from 'classnames';

import { IConDefaultType } from '..';

export enum MoveLargeIconVariant {
  PREVIOUS = 'previous',
  NEXT = 'next',
}

interface IMoveLargeIconProps extends IConDefaultType {
  variant?: MoveLargeIconVariant;
}

function MoveLargeIcon({
  color,
  className,
  size = 50,
  rotate,
  flip,
  variant = MoveLargeIconVariant.PREVIOUS,
}: IMoveLargeIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === MoveLargeIconVariant.PREVIOUS && (
        <svg viewBox="0 0 52 55" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_5972_184322)">
            <rect
              x="42"
              y="9"
              width="32"
              height="32"
              rx="16"
              transform="rotate(90 42 9)"
              fill="white"
              shapeRendering="crispEdges"
            />
            <rect
              x="41.5"
              y="9.5"
              width="31"
              height="31"
              rx="15.5"
              transform="rotate(90 41.5 9.5)"
              stroke="#E3E5E8"
              shapeRendering="crispEdges"
            />
            <path
              d="M28.4845 30.7248C28.827 30.3822 28.8499 29.8411 28.553 29.472L28.4845 29.3957L24.0892 25L28.4845 20.6043C28.827 20.2617 28.8499 19.7206 28.553 19.3516L28.4845 19.2752C28.142 18.9327 27.6008 18.9099 27.2318 19.2067L27.1555 19.2752L21.4307 25L27.1555 30.7248C27.5225 31.0917 28.1175 31.0917 28.4845 30.7248Z"
              fill="#ADB0B8"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_5972_184322"
              x="0"
              y="3"
              width="52"
              height="52"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.408333 0 0 0 0 0.408333 0 0 0 0 0.408333 0 0 0 0.2 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5972_184322" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5972_184322" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {variant === MoveLargeIconVariant.NEXT && (
        <svg viewBox="0 0 52 55" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_5972_184323)">
            <rect
              x="42"
              y="9"
              width="32"
              height="32"
              rx="16"
              transform="rotate(90 42 9)"
              fill="white"
              shapeRendering="crispEdges"
            />
            <rect
              x="41.5"
              y="9.5"
              width="31"
              height="31"
              rx="15.5"
              transform="rotate(90 41.5 9.5)"
              stroke="#E3E5E8"
              shapeRendering="crispEdges"
            />
            <path
              d="M23.5155 19.2752C23.173 19.6178 23.1501 20.1589 23.447 20.528L23.5155 20.6043L27.9108 25L23.5155 29.3957C23.173 29.7383 23.1501 30.2794 23.447 30.6484L23.5155 30.7248C23.858 31.0673 24.3992 31.0901 24.7682 30.7933L24.8445 30.7248L30.5693 25L24.8445 19.2752C24.4775 18.9083 23.8825 18.9083 23.5155 19.2752Z"
              fill="#ADB0B8"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_5972_184323"
              x="0"
              y="3"
              width="52"
              height="52"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.408333 0 0 0 0 0.408333 0 0 0 0 0.408333 0 0 0 0.2 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5972_184323" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5972_184323" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
    </i>
  );
}

export default MoveLargeIcon;
